import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { LearningPath } from 'types';

import 'components/OfferingCardBuilder/styles.scss';
import OfferingCardBuilder from 'components/OfferingCardBuilder';

type SkillsPathCardProps = {
  className?: string;
  learningPath: LearningPath;
  progress?: number;
};

const SkillsPathCard = ({
  className,
  learningPath,
  progress = 0,
}: SkillsPathCardProps) => {
  const { t, i18n } = useTranslation();

  const { title, path_type: pathType } = learningPath;

  const progressPercentage =
    progress || Math.round((learningPath.user_progress ?? 0) * 100);

  const pathTitle = useMemo(
    () =>
      learningPath.translations?.find((tr) => tr.language === i18n.language)
        ?.title ?? title,
    [learningPath.translations, i18n.language, title],
  );

  const customBadgeText = useMemo(() => {
    if (pathType === 'custom') {
      return t('Custom');
    }
    return t('Curated');
  }, [pathType, t]);

  return (
    <OfferingCardBuilder learningPath={learningPath} className={className}>
      <OfferingCardBuilder.Header progress={progressPercentage / 100} />
      <OfferingCardBuilder.Body
        className="skills-path-card_body"
        title={pathTitle}
        customBadge={customBadgeText}
      />
      <OfferingCardBuilder.Footer />
    </OfferingCardBuilder>
  );
};

export default SkillsPathCard;
